const translations = {
    cityFieldLabel: 'CITY'
};

export default translations;
